import React from 'react';
import { HStack, Box, ChakraInput, Icons } from '@shared/ui';
import { useProductCount } from './useProductCount';

interface ProductCounterPropTypes {
    id: string;
    quantity: number;
    onChange: (cartId: string, quantity: number) => void;
    min?: number;
    max?: number;
    isDisabled?: boolean;
}

export const ProductCounter: React.FC<ProductCounterPropTypes> = (props) => {
    const { id, quantity, onChange, min = 0, max, isDisabled = false } = props;

    const productCountApi = useProductCount({
        productQuantity: quantity,
        min,
        max,
        onChange: (value) => onChange(id, value),
    });

    return (
        <HStack
            display="inline-flex"
            height="32px"
            fontSize="xs"
            color="neutral.120"
            border="1px solid"
            borderColor="neutral.020"
            borderRadius="base"
            alignItems="stretch"
            gap="0"
            bg="neutral.000"
            {...(isDisabled && {
                opacity: 0.5,
                cursor: 'not-allowed',
                pointerEvents: 'none',
            })}
        >
            <Box
                as="button"
                role="button"
                _disabled={{
                    color: 'neutral.050',
                }}
                borderRightWidth="1px"
                borderColor="neutral.020"
                p="9px 6px"
                {...productCountApi.dec}
            >
                <Icons.csr.Minus size="14px" weight="bold" />
            </Box>
            <ChakraInput
                w="unset"
                minW="32px"
                h="100%"
                p="0 6px"
                border="none"
                textAlign="center"
                htmlSize={productCountApi.input.value.toString().length || 1}
                borderRadius="none"
                {...productCountApi.input}
            />
            <Box
                as="button"
                role="button"
                _disabled={{
                    color: 'neutral.050',
                }}
                borderLeftWidth="1px"
                borderColor="neutral.020"
                p="9px 6px"
                {...productCountApi.inc}
            >
                <Icons.csr.Plus size="14px" weight="bold" />
            </Box>
        </HStack>
    );
};
